<template>
    <div>
        <v-dialog
            v-model="showConfirmDialog"
            class="opt-confirm-dialog"
            status="warning"
            kind="confirm"
            :title="confirmTitle || $t('确认执行此操作？')"
            :confirm-loading="confirmLoading"
            @confirm="confirmClick"
        >
            <slot name="content"></slot>
            <span slot="confirm-text">{{ confirmBtnTxt || $t('确定') }}</span>
            <span slot="cancel-text">{{ $t('取消') }}</span>
        </v-dialog>

        <v-dialog
            v-model="showValidateDialog"
            class="mobile-validate-dialog"
            status="warning"
            kind="confirm"
            :title="$t('此属于敏感操作，需要验证管理员手机号')"
            :confirm-loading="verifyLoading"
            @confirm="handleSyncCancel"
        >
            <i18n-t path="验证码已发送到管理员手机号{mobile}" tag="div">
                <span slot="mobile">{{ adminMobile }}</span>
            </i18n-t>
            <div class="verify-code">
                <v-input v-model="smsVerifyCode" name="smsVerifyCode" :placeholder="$t('请输入验证码')"> </v-input>
                <v-button status="primary" :disabled="syncCancelSmSTime > 0" @click="startSmsVerify">{{
                    syncCancelSmSTime > 0 ? $t('{n}s', { n: syncCancelSmSTime }) : $t('重新获取')
                }}</v-button>
            </div>
            <p v-if="codeError" class="code-error-tip">{{ errMsg }}</p>
            <p />
            <span slot="confirm-text">{{ $t('验证并{action}', { action: confirmBtnTxt || $t('确定') }) }}</span>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        confirmTitle: {
            type: String,
            default: ''
        },

        confirmBtnTxt: {
            type: String,
            default: ''
        },

        custConfirmClick: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showConfirmDialog: false,
            showValidateDialog: false,
            verifyLoading: false,
            confirmLoading: false,
            syncCancelSmSTime: 0,
            syncCancelTimer: null, // 定时器
            smsVerifyCode: '',
            adminMobile: '', // 管理员手机号
            codeError: false, // 验证码是否错误
            errMsg: ''
        };
    },

    methods: {
        showConfirm() {
            this.showConfirmDialog = true;
        },

        showVerifyLoading() {
            this.verifyLoading = true;
        },

        hideVerifyLoading() {
            this.verifyLoading = false;
        },

        hideVerify() {
            this.showValidateDialog = false;
        },

        showVerifyError(msg) {
            this.codeError = true;
            this.errMsg = msg;
        },

        hideVerifyError() {
            this.codeError = false;
        },

        // 确认取消同步
        handleSyncCancel(e) {
            e.preventDefault();
            if (this.smsVerifyCode) {
                this.codeError = false;
                this.$emit('verify', this.smsVerifyCode);
            } else {
                this.codeError = true;
                this.errMsg = this.$t('验证码不能为空');
            }
        },

        confirmClick(e) {
            if (this.custConfirmClick) {
                this.$emit('confirmClick', e);
            } else {
                this.startSmsVerify(e);
            }
        },

        // 开始短信验证
        startSmsVerify(e) {
            e.preventDefault();
            this.confirmLoading = true;
            this.$ajax
                .get('/mng/weworkAccount/sendVerifyCode', { customFn: (res) => {
                    this.confirmLoading = false;
                    this.$message.error(res.message || this.$t('发送管理员验证码错误'));
                }})
                .then(res => {
                    const { code, message, data } = res || {};
                    const { mobile } = data || {};

                    if (code === 0) {
                        this.adminMobile = mobile;
                        this.showConfirmDialog = false;
                        this.showValidateDialog = true;
                        this.smsVerifyCode = '';
                        this.codeError = false;
                        this.sendSmsVerify();
                    }
                })
                .catch(res => {
                    const { message } = res || {};
                    this.$message.error(message || this.$t('发送管理员验证码错误'));
                    this.confirmLoading = false;
                });
        },

        // 发送短信
        sendSmsVerify() {
            if (this.syncCancelTimer) {
                clearInterval(this.syncCancelTimer);
            }

            this.syncCancelSmSTime = 60;

            this.syncCancelTimer = setInterval(() => {
                if (this.syncCancelSmSTime > 0) {
                    this.syncCancelSmSTime = this.syncCancelSmSTime - 1;
                } else {
                    clearInterval(this.syncCancelTimer);
                }
            }, 1000);
        }
    }
};
</script>

<style lang="less" scoped>
@import './mobile-validate-dialog.less';
</style>
